module.exports = __webpack_public_path__ + "d9ed4c356c4c2a91c7bfaaab5ad690a8.pdf";